import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { companyInfo } from "./RunzeweContent";
import { MdArrowForward, MdPhone, MdShield } from "react-icons/md";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="home-hero">
      <div className="home-hero-copy" data-aos="fade-right">
        <div className="hero-watermark" />
        <p className="section-kicker">{companyInfo.tagline}</p>
        <h1>Safety, Discipline, and Integrity</h1>
        <p className="hero-lead">
          Runzewe Security Company Limited delivers trusted guarding and technical
          security services that protect people, property, and assets with
          unwavering professionalism.
        </p>

        <div className="hero-actions">
          <button className="btn-runzewe btn-runzewe-primary" onClick={() => appContext.navTo({ item: "services" })}>
            <span>Our Services</span>
            <MdArrowForward />
          </button>

          <button className="btn-runzewe btn-runzewe-outline" onClick={() => appContext.navTo({ item: "contact" })}>
            <span>Contact Us</span>
            <MdPhone />
          </button>
        </div>
      </div>

      <div className="home-hero-media" data-aos="fade-left" data-aos-delay="120">
        <img src={companyInfo.heroImage} alt="Runzewe Security guards on duty" />
        <div className="hero-duty-badge">
          <MdShield />
          <span>Always on guard</span>
        </div>
      </div>
    </section>
  );
}
